<template>
  <footer class="footer">
    <div class="container-fluid d-flex flex-wrap justify-content-between">
<!--      <span class="footer-text">-->
<!--        Energy Tip: On warm days, setting a programmable thermostat to a higher setting when you are not at home can help reduce your energy costs by approximately 10 percent.-->
<!--      </span>-->
    </div>
  </footer>
</template>
<script>
export default {};
</script>
<style>
.footer-text {
  font-family: 'Nunito Sans Light';
  font-size: 15px;
  color: white;
}
</style>
